import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      try {
        const Email = localStorage.getItem("email");
        const RoleRaw = localStorage.getItem("role");
        const Token = localStorage.getItem("token");

        const Role = (RoleRaw || "").toUpperCase();

        /* ============================
           🔐 Basic Check
        ============================ */
        if (!Email || !Role || !Token) {
          localStorage.clear();
          navigate("/user/sign_in", { replace: true });
          return;
        }

        /* ============================
           📡 API Call
        ============================ */
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/check-user`,
          {
            Email,
            Role,
            Token,
          },
           { headers: { Authorization: `Bearer ${Token}` } }
        );

        /* ============================
           ✅ Success Handling
        ============================ */
        if (res.data.success) {
          if (res.data.ProfilePhotoUrl) {
            localStorage.setItem(
              "profilePhotoUrl",
              res.data.ProfilePhotoUrl
            );

            console.log(res.data.ProfilePhotoUrl);
            
          }

          /* ============================
             🔁 Role-based Redirect
          ============================ */
          switch (Role) {
            case "ADMIN":
              navigate("/user/admin-home-page", { replace: true });
              break;

            case "INSTRUCTOR":
              navigate("/user/instructor-home-page", { replace: true });
              break;

            case "OPERATIONS":
              navigate("/user/operations-home-page", { replace: true });
              break;

            case "STUDENT":
              navigate("/user/student-home-page", { replace: true });
              break;

            default:
              throw new Error("Invalid role");
          }
        } else {
          throw new Error("Invalid session");
        }

      } catch (error) {
        console.error("Auth Error:", error);

        /* ============================
           ❌ Logout + Redirect
        ============================ */
        localStorage.clear();
        navigate("/user/sign_in", { replace: true });
      }
    };

    init();
  }, [navigate]);

  return null;
}

export default Home;